<template>
  <v-app :dark="$root.config.dark" id="app" v-if="$root.ready">
    <v-toolbar dense dark app :color="$config.colors.primary" :class="['unselectable']">
      <v-toolbar-side-icon :class="['hidden-md-and-up']" @click="nav = !nav" aria-label="toggle-sidebar">
        <v-icon>menu</v-icon>
      </v-toolbar-side-icon>
      <v-toolbar-title v-html="$config.appName.toUpperCase()" :class="['hidden-md-and-up']" />
      <header-links :class="['hidden-sm-and-down']" />
    </v-toolbar>
    <v-navigation-drawer app clipped v-model="nav" :class="['elevation-8']">
      <navigation />
    </v-navigation-drawer>
    <v-content>
      <page-header />
      <router-view />
    </v-content>
    <v-footer app dense :class="['py-4']">
      <footer-player v-if="$config.footerPlayer" />
      <v-spacer />
      <template v-if="$root.playerMinimized">
        <v-btn :title="$lang.togglePlayer(!$root.playerMinimized)" flat icon @click="maximizePlayer()" :class="['ma-0']">
          <v-icon :color="$config.colors.success">mdi-play-circle-outline</v-icon>
        </v-btn>
        <v-btn :title="$lang.closePlayer" flat icon @click="closePlayer" :class="['ma-0']">
          <v-icon :color="$config.colors.danger">mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
      <v-btn flat :title="link.label" target="_blank" :aria-label="link.label.toLowerCase().replace(/ /g, '-')" :href="link.url" :class="['ma-0']" icon rel="noopener" v-for="(link, index) in links" :key="index">
        <v-icon>{{ link.icon }}</v-icon>
      </v-btn><span :class="['mr-4', 'ml-2', 'caption']">&copy;{{ $config.copyrightStartYear }} - {{ date.getFullYear() }}</span>
    </v-footer>
    <floating-player @close="closePlayer" :album="floatingPlayerId" v-if="floatingPlayerId" />
    <lightbox />
    <loading-overlay v-if="$root.ajax" />
    <social-services />
    <div :class="['floating-player-bounds']" />
    <v-snackbar :color="$config.colors.primary" v-model="$root.notification" bottom left>
      {{ $root.notificationText }}
      <v-btn small color="white" flat @click="$root.notification = false" :title="$lang.close" aria-label="close-notification">{{ $lang.close }}</v-btn>
    </v-snackbar>
    <cookie-consent v-if="!$root.cookieConsent && $root.$config.cookieConsentEnabled" :message="$lang.weUseCookies" :color="$root.config.colors.primary" />
    <vc-style>
    aside .v-list .v-list__tile--active .v-icon,
    aside .v-list .v-list__tile--active .v-list__tile__title
    {
      color: {{ $root.config.colors.hex }} !important;
    }
    </vc-style>
  </v-app>
</template>
<script>
import HeaderLinks from './components/header-links'
import FooterPlayer from './components/footer-player'
import PageHeader from './components/page-header'
import LoadingOverlay from './components/loading-overlay'
import Navigation from './components/navigation'
import CookieConsent from './components/cookie-consent'
import links from './helpers/links'
import methods from './mixins/methods'

export default {
  name: 'App',
  components: {
    PageHeader,
    Navigation,
    HeaderLinks,
    FooterPlayer,
    CookieConsent,
    LoadingOverlay
  },
  mixins: [
    methods
  ],
  data () {
    return {
      links,
      nav: false,
      date: new Date(),
      floatingPlayerId: null
    }
  },
  created () {
    this.bind()
  },
  methods: {
    bind () {
      this.$root.$on('play-album', (album) => {
        this.$root.playerMinimized = false
        this.floatingPlayerId = album
      })
    },
    closePlayer () {
      this.floatingPlayerId = null
      this.$root.playerMinimized = false
      this.gtagEvent('player', 'close')
    },
    maximizePlayer () {
      this.$root.playerMinimized = false
      this.gtagEvent('player', 'maximize')
    }
  }
}
</script>
<style>
html
{
  cursor: default;
  scroll-behavior: smooth;
}

*
{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.body--theme--dark::-webkit-scrollbar,
.body--theme--dark::-webkit-scrollbar-track,
.body--theme--dark ::-webkit-scrollbar,
.body--theme--dark ::-webkit-scrollbar-track
{
  background-color: #424242;
}

.body--theme--dark::-webkit-scrollbar,
.body--theme--dark ::-webkit-scrollbar
{
  width: 15px;
}

.body--theme--dark::-webkit-scrollbar-thumb,
.body--theme--dark ::-webkit-scrollbar-thumb
{
  background-color: #212121 !important;
}

.unselectable
{
  user-select: none;
}

.clickable
{
  cursor: pointer;
}

.pointer-events-none
{
  pointer-events: none;
}

.full-height
{
  height: 100%;
}

.avatar-wrapper
{
  display: inline-block;
  border-radius: 100%;
}

[hidden]
{
  display: none !important;
}

.bw-image-filter .v-image__image,
.blogpost-item .v-image .v-image__image
{
  filter: grayscale(90%) brightness(60%);
  transition: all .25s ease-in-out;
}

.bw-image-filter:hover .v-image__image,
.blogpost-item:hover .v-image .v-image__image
{
  filter: none;
}

.videos-list iframe
{
  display: block;
  border: 0;
  overflow: hidden;
}

.video-wrapper
{
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  background: center no-repeat url('/static/images/replacement-image.jpg');
  background-size: cover;
}

.video-wrapper::after,
.video-wrapper iframe
{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.first-letter-uppercase:first-letter
{
  text-transform: uppercase;
}

.opacity-50
{
  opacity: .5;
}
</style>



// WEBPACK FOOTER //
// src/app.vue